import { UploadFile } from "@mui/icons-material";
import { Box, Card, CircularProgress, Grid, Icon, IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { memo, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { postUploadNoResponse } from "utils/WebService";

const UploadArquivoForum = ({ closeCreateEdit }) => {
    const [isLoadingUpload, setIsLoadingUpload] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [enviando, setEnviando] = useState(false);


    const handleSubmit = (file) => {
        setEnviando(true);
        if (!file) {
            errorAlert('Selecione um arquivo antes de enviar.');
            setEnviando(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        postUploadNoResponse(`/forum/upload`, formData)
            .then(() => {
                successAlert("Upload realizado com sucesso.", handleSucess())
            }).catch((error) => {
                console.log(error)
                errorAlert('Erro ao enviar arquivo.');
            }).finally(() => {
                setEnviando(false);
                setFileName(null);
                setFile(null);
            });
    };

    function handleSucess() {
        closeCreateEdit();
    }

    const onFileChange = async ({ target }) => {
        setIsLoadingUpload(true)
        const file = target.files[0];
        if (file) {
            setFileName(file.name);
            setFile(file);
            setIsLoadingUpload(false);
        }
    };


    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h4">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h5">Upload Fóruns</MDTypography>
            </Box>

            <MDBox px={3}>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <MDButton
                            variant="contained"
                            component="label"
                            startIcon={(!isLoadingUpload && !fileName) && <UploadFile />}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mt: 2,
                                ml: 2,
                                minWidth: 'auto',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                                paddingRight: fileName ? 2 : 4.5
                            }}
                            color="info"
                            endIcon={isLoadingUpload ?
                                <CircularProgress
                                    color="white"
                                    size={20} sx={{ ml: 0, mr: 0 }} /> : null}
                        >
                            {!isLoadingUpload &&
                                <>
                                    {!fileName && "Upload"}
                                    <input
                                        type="file"
                                        accept=".csv,.txt"
                                        onChange={(e) => {
                                            onFileChange(e);
                                        }}
                                        hidden
                                    />
                                </>
                            }
                            {fileName && (
                                <span style={{
                                    marginLeft: '10px',
                                    color: '#ffff',
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {fileName}
                                </span>
                            )}
                        </MDButton>
                    </Grid>
                </Grid>
            </MDBox>
            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                <MDButton
                    size="large"
                    variant="contained"
                    color="info"
                    circular={false}
                    iconOnly={false}
                    onClick={() => handleSubmit(file)}
                    endIcon={enviando ?
                        <CircularProgress
                            color="inherit"
                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                    {!enviando && "Enviar"}
                </MDButton>
            </Box>
        </Card>
    );
}

export default memo(UploadArquivoForum);